<template>
    <div :class="['packGal reveal']" >   

        <div class="sectionTitle black">
            <splitter :content="localize(sectionData.title)"></splitter>
        </div>

        <!--
            < side arrows >
        <a class="navBtn right" @click="showNext"><i class="fal fa-chevron-right pl-s" ></i></a>
        <a class="navBtn left" @click="showPre"><i class="fal fa-chevron-left pl-s" ></i></a>
        -->

        <div class="scroller" ref="packScroller">
            <div class="packItem"
                v-bind:style="getBgStyle(index)"
                v-for="(item, index) in sectionData.items" :key="index">
            </div>          
        </div>

        <div class="pkgNavController">
            <sidepager                         
                @item-change ="sidepagerOnChange"
                :skinMode="1"
                v-bind:itemIndex="slideIndex" 
                v-bind:sectionIndex="secIndex">
            </sidepager>
        </div> 

    </div>
</template>

<style scoped>
    .packGal
    {
        width: 100vw;height: 100vh;
        top: 0px;left: 0px;
        overflow: hidden;
        background-color: var(--graybg1);
        z-index: 1102;
        display: grid;
        align-items: center;
        text-align: center;
        opacity: 1;
        position: relative;
    }
    .packGal .title
    {
        position: absolute;
        font-size: 22px !important;
        font-weight: 100 !important;        
        letter-spacing: -0.5px;
        color: #202020;
        text-align:center;        
        position:absolute;
        top:100px;width: 100%;
    }
  .packGal .navBtn{
    position: fixed;z-index: 2000;text-align: center;
    width: 100px;opacity: 1;cursor: pointer;
    transition: all ease 0.4s;
    transition-delay: 0.8s;
    opacity: 0;
  }
  .packGal .navBtn i{
    font-size: 90px;color:#babdc0;
  }
  .packGal .navBtn.right{
    top:50%;right:0px;transform: translate(-50%,-50%);   
  }
  .packGal .navBtn.left{
    top:50%;left:0px;transform: translate(50%,-50%);text-align: left;  
  }
  .packGal.active .navBtn.right{
    opacity: 1;
    right: -20px;
  }
  .packGal.active .navBtn.left{
    opacity: 1;
    left:-20px;
  }
    .packGal .pkgNavController
    {
        position: absolute;
        bottom: 100px;
        width: 300px;
        margin: auto;
        left: calc(50vw - 150px);    
    }

  .packGal .scroller
  {
    display: flex;
    gap: 0px;
    max-width: 100vw;
    height: 90%;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding: 120px;
    opacity: 0;
    transition: all ease 0.5s;
    transition-delay: 0.7s;
  }
  .packGal.active .scroller
  {
    opacity: 1;
  }
  .packGal .scroller::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
    .packItem
    {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 100vw;
        width: 100vw;
        height: 100%;
        scroll-snap-align: start;
        scroll-snap-stop: normal;
        text-align: center;
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;

    }
.packItem img{
    height: 50vh;
    width: auto;
    margin: auto;
}
.packGal .closebtn
{
    position: absolute;top: 2vw;right:3vh;
}

@media (max-width: 850px) { 
    .packGal{
        min-height: inherit;
        width: 100vw !important;
        height: auto;
        display: block;  
        padding-bottom: 100px;      
    }    
    .packGal .sectionTitle
    {
        position: initial;
        padding-top: 100px;
    }
    .packGal .scroller{
        height: 50vh;
        width: 100%;
        padding: 0px 0px;
    }                
    .packGal .closebtn{
        position: absolute;
        top: 3vh;
        right:3vh;
    }
    .packItem{

    }
    .packGal .navBtn{
        display: none;
    }
    .packGal .scroller .packItem img
    {
        width: 100vw;
        height: auto;
    }
    .packGal .pkgNavController
    {
        position: initial;
        width: 100%;
    }

}

@media (max-width: 850px) and (orientation:landscape) {
    .packGal .scroller{
        height: 100vh;width: 100%;padding: 60px 30px;
    }                 
    .packGal .pkgNavController
    {
        position: initial;
        padding: 10px 0px 0px 0px;
    }    
}

  @media (hover: hover){
    .packGal .navBtn:hover i{
        color:#202020;
    }
  }




</style>
<script>
    import { mapActions, mapState } from "vuex";
    import splitter from "@/views/com/splitter.vue";
    import sidepager from "@/views/com/sidepager.vue";
    import { splitLines,isMobileScreen }         from "@/utils";

    export default {
        components:{splitter,sidepager},
        props: {
            openIndex:Number
        },
        watch: { 
            openIndex: function(newVal, oldVal) { 
                if(newVal>-1){
                    
                }            
            },
            '$store.state.siteVisibleSection': function() {
                var vm=this;
                let _siteVisibleSection = this.$store.state.siteVisibleSection;
                if(_siteVisibleSection==vm.secIndex+1){
                    if(isMobileScreen()==false){
                        vm.startAutoChange();
                    }
                }
            }

        },        
        mounted()
        {
            this.initImgScroller();
        },
        destroyed() {
            this.removeImgScroller();
        },
        methods:
        {
            stopAutoChange()
            {
                if(this.intChanger){
                    clearInterval(this.intChanger);
                }
            },
            startAutoChange()
            {
                var vm=this;
                vm.intChanger = setInterval(() => {                    
                    if(vm.siteVisibleSection==vm.secIndex+1){
                        vm.moveToNextImage();
                    }                
                }, 6500);
            },
            moveToNextImage()
            {
                var vm=this;
                let newIndex = vm.slideIndex+1;
                if(newIndex>vm.sectionData.items.length-1){newIndex=0;}
                vm.navTo(newIndex,true);                
            },
            initImgScroller() 
            {
                var vm = this;
                let scroller = this.$refs.packScroller;
                scroller.addEventListener("scroll", vm.checkScrollPosition, false);   
            },
        removeImgScroller() {
            var vm = this;
            let scroller = this.$refs.packScroller;
            scroller.removeEventListener("scroll", vm.checkScrollPosition);
        },
        checkScrollPosition() {
            //alert("benefits scroll");
            var vm=this;
            let scroller = this.$refs.packScroller;
            let scrX = scroller.offsetLeft;
            let scrolledX = scroller.scrollLeft;
            var reveals = scroller.querySelectorAll(".packItem");
            for (var i = 0; i < reveals.length; i++) {
                let diff = Math.abs(scrolledX-reveals[i].offsetLeft);
                if(diff<10){
                    this.slideIndex = i;
                }
            }
            
            },            
            sidepagerOnChange(index)
            {
                this.navTo(index,false);
            },
            getBgStyle(index)
            {
                return "background-image: url('"+this.sectionData.items[index].img+"');";
            },
            showPre()
            {
                let sIndex = this.slideIndex-1;
                if(sIndex<0){sIndex=0;}
                this.navTo(sIndex,false);
            },
            showNext(){
                let sIndex = this.slideIndex+1;
                if(sIndex>3){sIndex=3;}
                this.navTo(sIndex,false);
            },
            closeGal(){
                this.$emit("close-gal");
            },
            navTo(index,fromTimer)
            {
                if(fromTimer==false){
                    this.stopAutoChange()
                }

                this.slideIndex = index;
                //document.getElementsByClassName("packItem")[index].scrollIntoView({ behavior: 'smooth' });
                let scrollToElement = this.$refs.packScroller.getElementsByClassName("packItem")[index];
                scrollToElement.scrollIntoView(
                { 
                    behavior: 'smooth',
                    inline:'center',
                    block:'nearest' }
                );
            },
        },
        data()
        {
            return {
                slideIndex:0,
                secIndex:8,
                logger:'',
                intChanger:Object
                
                }
        },
        computed:
        {
            ...mapState(["siteData","siteDataReady","siteVisibleSection"]),
            sectionData(){
                return this.siteData.SECTIONS[8];
            }
        }        
    }
</script>  
